<template>
  <base-data-table
    :items="frequentSupports"
    title="頻回対応"
    header-icon="mdi-account-group-outline"
    :column-widths="['160px', '140px', '', '120px']"
  >
    <template #header-actions>
      <v-btn
        color="#3ACAC9"
        variant="flat"
        size="small"
        prepend-icon="mdi-plus"
        class="text-white"
        @click="$emit('add-support')"
      >
        新規登録
      </v-btn>
    </template>
    <template #header-cells>
      <th>対応日時</th>
      <th>対応</th>
      <th>対応補足</th>
      <th />
    </template>
    <template #cells="{ row: frequentSupport }">
      <td>{{ frequentSupport.supportedAt }}</td>
      <td>
        <v-chip
          class="warning-mail-chip"
          size="x-small"
          variant="flat"
        >
          {{ frequentSupport.supportType }}
        </v-chip>
      </td>
      <td>
        <div class="base-data-table-two-line-clamp">{{ frequentSupport.note }}</div>
      </td>
      <td class="base-data-table-action-cell">
        <v-btn
          color="#3ACAC9"
          variant="outlined"
          size="small"
          @click="$emit('open-detail', frequentSupport)"
        >
          詳細を開く
        </v-btn>
      </td>
    </template>
  </base-data-table>
</template>

<script>
import BaseDataTable from "./BaseDataTable.vue";

export default {
  name: "FaceSheetFrequentSupportTable",
  components: {
    BaseDataTable
  },
  props: {
    frequentSupports: {
      type: Array,
      default: () => []
    }
  },
  emits: ["add-support", "open-detail"]
};
</script>

<style lang="scss" scoped>
.warning-mail-chip {
  background-color: #ffe7ec;
  color: #ef5d7a;
  font-weight: bold;
}
</style>
